export class Service{
  constructor(
    public ID:number,
    private name:string,
    public price:number
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/service.model.ts